import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthTokenService } from '../services/auth-token.service';
import { AuthService } from '../api/auth.service';
import { catchError, switchMap, throwError, from } from 'rxjs';
import { environment } from '../../../environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authTokenService = inject(AuthTokenService);
  const authService = inject(AuthService);

  const token = authTokenService.getToken();

  // Bypass token injection for requests matching excluded URLs
  if (environment.authTokenExcludedUrls.some(url => req.url.includes(url))) {
    return next(req);
  }

  // Adding app token into header
  const authReq = token
    ? req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
    : req;

  return next(authReq).pipe(
    catchError((error) => {
      let errorObj = error.error;

      if (typeof error.error === 'string') {
        try {
          errorObj = JSON.parse(error.error);
        } catch (_) {
          // parsing failed, leave it as-is
        }
      }

      // Getting new token if expired or doesen't exist and calling request again with new token
      if (
        error.status === 401 &&
        (errorObj.code === 'SVC-4000' || errorObj.code === 'SVC-4001' || errorObj.code === 'SVC-4003')
      ) {
        return authService.getAppToken().pipe(
          switchMap((appTokenResponse) => {
            if (!appTokenResponse.access_token) {
              return throwError(() => error);
            }

            authTokenService.saveToken(appTokenResponse.access_token);

            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${appTokenResponse.access_token}`,
              },
            });

            return next(retryReq);
          }),
          catchError((tokenError) => {
            return throwError(() => tokenError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
